import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#2C3B4E",
      stroke: "#2C3B4E",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      d: "m1.817 4.524 9.1-3.568a2.94 2.94 0 0 1 2.162 0l9.1 3.568a1.76 1.76 0 0 1 1.071 1.662v11.628a1.76 1.76 0 0 1-1.067 1.662l-9.1 3.57a2.96 2.96 0 0 1-2.162 0l-9.1-3.57A1.76 1.76 0 0 1 .75 17.814V6.186a1.76 1.76 0 0 1 1.067-1.662"
    }, null, -1),
    _createElementVNode("path", {
      stroke: "#F1F4F9",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      d: "M12 9.354-1.5 4M12 9.354 26 4M12 25.001V9.354"
    }, null, -1)
  ])))
}
export default { render: render }